import { render, staticRenderFns } from "./PopupComponent.vue?vue&type=template&id=29ebd2f4&scoped=true"
import script from "./PopupComponent.vue?vue&type=script&lang=js"
export * from "./PopupComponent.vue?vue&type=script&lang=js"
import style0 from "./PopupComponent.vue?vue&type=style&index=0&id=29ebd2f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ebd2f4",
  null
  
)

export default component.exports